var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 35.863 34.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18771",
    "data-name": "Group 18771",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35538",
    "data-name": "Path 35538",
    d: "M46.352,264.841a3.688,3.688,0,0,1-3.684-3.684v-1.474a3.684,3.684,0,1,1,7.367,0v1.474A3.688,3.688,0,0,1,46.352,264.841Zm0-7.367a2.213,2.213,0,0,0-2.21,2.21v1.474a2.21,2.21,0,0,0,4.42,0v-1.474A2.213,2.213,0,0,0,46.352,257.473Zm0,0",
    transform: "translate(-39.721 -238.318)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35539",
    "data-name": "Path 35539",
    d: "M4.42,371.507a6.369,6.369,0,0,1-4.2-1.69A.733.733,0,0,1,0,369.3v-2.553a1.468,1.468,0,0,1,.657-1.227l4.092-2.727a.737.737,0,0,1,.818,1.226l-4.093,2.728v2.216a4.9,4.9,0,0,0,2.947,1.073.737.737,0,0,1,0,1.474Zm0,0",
    transform: "translate(0 -337.617)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35540",
    "data-name": "Path 35540",
    d: "M111.416,366.964,107,364.017a.738.738,0,0,1-.328-.613v-.737h1.473v.342l4.093,2.728Zm0,0",
    transform: "translate(-99.3 -337.619)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35541",
    "data-name": "Path 35541",
    d: "M206.352,264.841a3.688,3.688,0,0,1-3.684-3.684v-1.474a3.684,3.684,0,0,1,7.367,0v1.474A3.688,3.688,0,0,1,206.352,264.841Zm0-7.367a2.213,2.213,0,0,0-2.21,2.21v1.474a2.21,2.21,0,0,0,4.42,0v-1.474A2.213,2.213,0,0,0,206.352,257.473Zm0,0",
    transform: "translate(-188.67 -238.318)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35542",
    "data-name": "Path 35542",
    d: "M160.737,368.559a.737.737,0,0,1-.737-.737v-1.079a1.468,1.468,0,0,1,.657-1.227l4.092-2.727a.737.737,0,0,1,.818,1.226l-4.093,2.728v1.079A.737.737,0,0,1,160.737,368.559Zm0,0",
    transform: "translate(-148.949 -337.616)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35543",
    "data-name": "Path 35543",
    d: "M271.824,368.559a.736.736,0,0,1-.737-.737v-1.079L267,364.015a.737.737,0,1,1,.818-1.226l4.093,2.728a1.471,1.471,0,0,1,.656,1.226v1.079A.736.736,0,0,1,271.824,368.559Zm0,0",
    transform: "translate(-248.249 -337.616)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35544",
    "data-name": "Path 35544",
    d: "M366.352,264.841a3.688,3.688,0,0,1-3.684-3.684v-1.474a3.684,3.684,0,1,1,7.367,0v1.474A3.688,3.688,0,0,1,366.352,264.841Zm0-7.367a2.213,2.213,0,0,0-2.21,2.21v1.474a2.21,2.21,0,0,0,4.42,0v-1.474A2.213,2.213,0,0,0,366.352,257.473Zm0,0",
    transform: "translate(-337.619 -238.318)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35545",
    "data-name": "Path 35545",
    d: "M325.575,366.965l-.817-1.226,4.092-2.728v-.342h1.473v.737a.738.738,0,0,1-.328.613Zm0,0",
    transform: "translate(-302.327 -337.619)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35546",
    "data-name": "Path 35546",
    d: "M428.134,371.506a.737.737,0,0,1,0-1.474,4.853,4.853,0,0,0,2.947-1.07v-2.219l-4.093-2.728a.737.737,0,1,1,.818-1.226l4.093,2.728a1.472,1.472,0,0,1,.656,1.226V369.3a.733.733,0,0,1-.216.521,6.369,6.369,0,0,1-4.2,1.689Zm3.684-2.21h0Zm0,0",
    transform: "translate(-397.191 -337.616)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35547",
    "data-name": "Path 35547",
    d: "M77.644,470.806H54.069a.737.737,0,1,1,0-1.474H77.644a.737.737,0,1,1,0,1.474Zm0,0",
    transform: "translate(-49.648 -436.916)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35548",
    "data-name": "Path 35548",
    d: "M71.4,16.208a.737.737,0,0,1-.737-.737V14.415L68.6,13.177a.734.734,0,0,1-.345-.5,10.81,10.81,0,0,0-.431-1.59.739.739,0,0,1,.052-.6l1.171-2.108-.32-.554-2.409-.041a.735.735,0,0,1-.545-.256,11.211,11.211,0,0,0-1.166-1.166.736.736,0,0,1-.256-.546l-.04-2.41-.554-.32L61.648,4.26a.736.736,0,0,1-.6.052,10.912,10.912,0,0,0-1.592-.43.738.738,0,0,1-.5-.346L57.722,1.473h-.639L55.844,3.537a.736.736,0,0,1-.5.345,10.806,10.806,0,0,0-1.591.43.737.737,0,0,1-.6-.052L51.048,3.09l-.553.32-.04,2.41a.737.737,0,0,1-.256.545,11.211,11.211,0,0,0-1.166,1.166.737.737,0,0,1-.545.256l-2.411.041-.32.553,1.171,2.109a.736.736,0,0,1,.052.6,10.757,10.757,0,0,0-.43,1.59.737.737,0,0,1-.345.5l-2.064,1.238v1.057a.737.737,0,1,1-1.473,0V14a.736.736,0,0,1,.357-.632l2.143-1.286c.084-.383.189-.771.315-1.16L44.267,8.732a.736.736,0,0,1,.006-.727l.737-1.276a.738.738,0,0,1,.626-.368l2.5-.042c.268-.3.553-.579.847-.847l.042-2.5a.737.737,0,0,1,.368-.625l1.276-.737A.736.736,0,0,1,51.4,1.6l2.189,1.216c.389-.125.777-.231,1.16-.315L56.034.357A.736.736,0,0,1,56.666,0h1.474a.736.736,0,0,1,.631.358L60.055,2.5q.576.126,1.16.315L63.4,1.6a.736.736,0,0,1,.726.006l1.276.737a.737.737,0,0,1,.368.626l.042,2.5c.295.268.578.552.847.848l2.5.042a.738.738,0,0,1,.626.368l.737,1.276a.734.734,0,0,1,.006.726L69.322,10.92c.127.393.231.777.315,1.16l2.143,1.286a.739.739,0,0,1,.357.632v1.473a.737.737,0,0,1-.737.737Zm0,0",
    transform: "translate(-39.721 0)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35549",
    "data-name": "Path 35549",
    d: "M162.165,114.773a.675.675,0,0,1-.675-.676v-.676a5.4,5.4,0,1,0-10.807,0v.676a.676.676,0,1,1-1.351,0v-.676a6.754,6.754,0,0,1,13.509,0v.676A.675.675,0,0,1,162.165,114.773Zm0,0",
    transform: "translate(-138.405 -98.565)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeInformation);
export default __webpack_public_path__ + "static/media/employeeInformation.30580f5ad3f7d75fcb3ae13df0dc5bb3.svg";
export { ForwardRef as ReactComponent };